import { render } from "./BlockBarContext.vue?vue&type=template&id=7fdbd24d&scoped=true&ts=true"
import script from "./BlockBarContext.vue?vue&type=script&lang=ts"
export * from "./BlockBarContext.vue?vue&type=script&lang=ts"

import "./BlockBarContext.vue?vue&type=style&index=0&id=7fdbd24d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdbd24d"]])

export default __exports__